module.exports = __webpack_public_path__ + "media/application/images/home/intro_images/feature_depth-afc8b9799eb17f1702a77ee6c6901c54.jpg";